/** KONE CRA dashboard card icon. */
export function KoneCraIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM11.3536 6.35359L7.35359 10.3536C7.15833 10.5489 6.84175 10.5489 6.64648 10.3536L4.64648 8.35359L5.35359 7.64648L7.00004 9.29293L10.6465 5.64648L11.3536 6.35359Z"
        fill="currentColor"
      />
    </svg>
  );
}
